import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: 'sm-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
})
export class CopyToClipboardComponent implements OnInit, OnChanges {

  private readonly tooltipTimeout = 2000;

  @Input() data = '';
  @Input() isAutoCopy = false;
  @Input() classes = 'w-6 h-6 bg-white tk-i-copy-blue-not-hover tk-i-copy-circle-gray-hover';

  @ViewChild(MatTooltip, {static: true}) matTooltip?: MatTooltip;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isAutoCopy)
      setTimeout(() => this.onCopyLink(this.matTooltip!), 500);
  }

  onCopyLink(tooltip: MatTooltip) {
    navigator.clipboard.writeText(this.data);

    tooltip.disabled = false;
    tooltip.show();
    setTimeout(() => {
      tooltip.disabled = true;
    }, this.tooltipTimeout);
  }

}
